import { createContext, useContext, useEffect, useState } from "react";
import { api, setAuthToken } from "./api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setAdmin(data);
      } catch {
        setAdmin(null);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) setAuthToken(data.token);
    setAdmin(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (err) { console.warn("Logout request failed:", err); }
    setAuthToken(null);
    setAdmin(null);
  };

  return (
    <AuthContext.Provider value={{ admin, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
